import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {DisplayContainer, ContactImage, TextSeciton, H1, KitButton} from './style'

export const ContactUsRow = () => {

    

    return (
        <>
            <DisplayContainer>
            <Container fluid>
                <Row>
                <Col>
                </Col>
                <Col>
                    <TextSeciton>
                        <H1>Interested in our KITS?</H1>
                        <H1>Get in touch with us!</H1>
                        <KitButton>Contact Us</KitButton>
                    </TextSeciton>
                </Col>
                <Col>
                </Col>
                </Row>
            </Container>
            </DisplayContainer>
        </>
    )
}
